<div class="main-container-position">
  <div class="container-width">
    <div class="py-8">
      <div class="flex items-center justify-between mb-8 flex-wrap">
        <div class="flex items-center space-x-2 order-1 md:order-none">
          <a routerLink="/company" class="text-black hover:cursor-pointer" i18n
            >Angebot Übersicht</a
            >
            <span class="text-gray-400">→</span>
            <span class="font-semibold text-black" i18n>Feedback zu Angebot</span>
          </div>
          <div class="order-2 md:order-none w-full md:w-auto mt-4 md:mt-0">
            <button
              class="flex items-center text-black hover:text-blue-500"
              routerLink="/feedback-history/{{ offer.id }}"
              >
              <span class="material-symbols-outlined">history</span>
              <span class="ml-2" i18n>Historie ansehen</span>
            </button>
          </div>
        </div>

        @if (loadingStates.offer || loadingStates.company) {
          <div>
            <app-skeleton-loading></app-skeleton-loading>
          </div>
        }

        @if (!loadingStates.offer && !loadingStates.company) {
          <div>
            @if (userIsAdmin) {
              <div class="mb-4">
                <button mat-raised-button color="primary" (click)="instantApprove()">
                  <mat-icon>check_circle</mat-icon>
                  Instant Approve
                </button>
              </div>
            }
            <!-- Offer Details -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div class="flex flex-col space-y-4">
                <div>
                  <label
                    for="title"
                    class="block text-sm font-medium text-gray-700 mb-1"
                    i18n
                    >Titel</label
                    >
                    <h1 class="text-3xl font-bold !mt-0 !mb-2">{{ offer.name }}</h1>
                  </div>
                  <!-- Offer Type and Appointment -->
                  <div class="flex flex-wrap gap-2">
                    <div
                      class="px-3 py-1 rounded-full text-sm bg-gray-700 text-white w-fit flex justify-center h-fit"
                      >
                      <mat-icon class="text-white text-sm">{{
                        offer.offerType.icon
                      }}</mat-icon>
                      <span class="ml-1">
                        {{ offer.offerType.offerName }}
                      </span>
                    </div>
                    @if(offer.appointmentDateTime && offer.offerType.requiresDate) {
                      <div
                        class="px-3 py-1 rounded-full text-sm bg-blue-100 text-blue-800 w-fit flex justify-center h-fit"
                        >
                        <mat-icon class="text-blue-800 text-sm">event</mat-icon>
                        <span class="ml-1">
                          {{
                          offer.appointmentDateTime | date : "dd.MM.yyyy HH:mm"
                          }}
                          Uhr
                        </span>
                      </div>
                    }
                  </div>
                  <div>
                    <label
                      for="description"
                      class="block text-sm font-medium text-gray-700 mb-1"
                      i18n
                      >Beschreibung</label
                      >
                      <div
                        [innerHTML]="offer.description"
                        class="mt-1 p-3 bg-gray-100 max-h-[500px] overflow-y-scroll"
                      ></div>
                    </div>
                    <!-- Company Details -->
                    @if(loadingStates.company) {
                      <app-skeleton-loading
                        [showLoadingText]="true"
                        [loadingText]="'Angebot von ...'"
                        [showTabs]="false"
                        [numberOfCards]="0"
                        [numberOfTabs]="0"
                        [containerClass]="'bg-gray-100 p-6 rounded-lg h-[250px]'"
                      ></app-skeleton-loading>
                    } @else {
                      <div class="bg-gray-100 p-6 rounded-lg">
                        <div class="text-md text-black leading-tight mb-4">
                          <p>
                            Angebot von:
                            <span class="font-bold">{{ company.companyName }}</span>
                          </p>
                        </div>
                        <p class="font-bold mb-2">Kontakt</p>
                        <p class="flex flex-row">
                          <span class="p-2 material-symbols-outlined"> location_on </span>
                          <span class="py-2"
                            >{{ company.address?.streetAndNumber }},
                            {{ company.address?.postalCode }}
                            {{ company.address?.city }}</span
                            >
                          </p>
                          <p class="flex flex-row">
                            <span class="p-2 material-symbols-outlined"> mail </span>
                            <span class="py-2">{{ company.email }}</span>
                          </p>
                          <p class="flex flex-row">
                            <span class="p-2 material-symbols-outlined"> call </span>
                            <span class="py-2">{{ company.phone }}</span>
                          </p>
                          @if(company.website) {
                            <p class="flex flex-row">
                              <span class="p-2 material-symbols-outlined"> language </span>
                              <a
                                href="{{ company.website }}"
                                target="_blank"
                                class="py-2 text-blue-600 hover:underline"
                                >{{ company.website }}</a
                                >
                              </p>
                            }
                          </div>
                        }
                      </div>
                      <div class="flex flex-col space-y-4">
                        <div>
                          <label
                            for="media"
                            class="block text-sm font-medium text-gray-700 mb-1"
                            i18n
                            >Medien</label
                            >
                            <div class="relative p-2">
                              <div class="w-full h-64 flex justify-center items-center">
                                <app-offer-media-display
                                  [offer]="offer"
                                  [showDownloadPdf]="true"
                                  style="height: inherit"
                                ></app-offer-media-display>
                              </div>
                            </div>
                          </div>
                          <div>
                            <label
                              for="categories"
                              class="block text-sm font-medium text-gray-700 mb-1"
                              i18n
                              >Kategorien</label
                              >
                              <div class="flex flex-wrap gap-2">
                                @for (category of offer.categories; track category) {
                                  <div
                                    class="px-3 py-1 rounded-full text-sm bg-green-100"
                                    >
                                    {{ category.name }}
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                        <h1 class="mt-12 mb-4">Feedback geben</h1>
                        <!-- Feedback Stepper Form -->
                        <form [formGroup]="feedbackForm">
                          <mat-stepper
                            [linear]="isLinear"
                            #stepper
                            [orientation]="isMobile ? 'vertical' : 'horizontal'"
                            >
                            <!-- Icon overrides. -->
                            <ng-template matStepperIcon="number" let-index="index">
                              {{ index + 1 }}
                            </ng-template>
                            <ng-template matStepperIcon="edit">
                              <mat-icon>done</mat-icon>
                            </ng-template>
                            <ng-template matStepperIcon="done">
                              <mat-icon>done</mat-icon>
                            </ng-template>
                            <ng-template matStepperIcon="check">
                              <mat-icon>done</mat-icon>
                            </ng-template>
                            <ng-template matStepperIcon="close">
                              <mat-icon>close</mat-icon>
                            </ng-template>
                            <!-- Step 1: Content Appropriate -->
                            <mat-step formGroupName="appropriateContent">
                              <div class="py-4">
                                <div class="flex flex-row items-center gap-2">
                                  <p class="text-lg font-semibold" i18n>Inhalt angemessen</p>
                                  <button
                                    class="text-blue-500 hover:text-blue-700"
                                    (click)="openInfoAppropiate()"
                                    i18n
                                    >
                    Was ist zu beachten
                  </button>
                                  <span class="material-symbols-outlined"> help </span>
                                </div>
                                <mat-radio-group
                                  formControlName="isAppropriate"
                                  class="flex flex-col space-y-2"
                                  >
                                  <mat-radio-button [value]="true" i18n>Ja</mat-radio-button>
                                  <mat-radio-button [value]="false" i18n>Nein</mat-radio-button>
                                </mat-radio-group>
                                @if (
                                  !feedbackForm.get('appropriateContent.isAppropriate')?.value
                                  ) {
                                  <div
                                    class="mt-4"
                                    >
                                    <mat-form-field class="w-full" appearance="outline">
                                      <textarea
                                        required
                                        matInput
                                        formControlName="reason"
                                        i18n-placeholder
                                        placeholder="Begründung"
                                        rows="3"
                                      ></textarea>
                                    </mat-form-field>
                                  </div>
                                }
                              </div>
                              <div class="flex justify-start">
                                @if (
                                  feedbackForm.get('appropriateContent.isAppropriate')
                                  ?.value !== false
                                  ) {
                                  <button
                                    matStepperNext
                                    class="button-blue"
                                    [disabled]="!feedbackForm.get('appropriateContent')?.valid"
                                    i18n
                                    >
                  Weiter
                </button>
                                }
                                @if (
                                  feedbackForm.get('appropriateContent.isAppropriate')
                                  ?.value === false
                                  ) {
                                  <button
                                    (click)="skipToLastStep()"
                                    class="button-blue"
                                    [disabled]="!feedbackForm.get('appropriateContent')?.valid"
                                    i18n
                                    >
                  Zur Entscheidung
                </button>
                                }
                              </div>
                            </mat-step>
                            <!-- Step 2: Category Correct -->
                            <mat-step formGroupName="category">
                              <div class="py-4">
                                <div class="flex flex-row items-center gap-2">
                                  <p class="text-lg font-semibold" i18n>Kategorie korrekt</p>
                                  <button
                                    class="text-blue-500 hover:text-blue-700"
                                    (click)="openInfoCategory()"
                                    i18n
                                    >
                    Was ist zu beachten
                  </button>
                                  <span class="material-symbols-outlined"> help </span>
                                </div>
                                <mat-radio-group
                                  formControlName="isCorrect"
                                  class="flex flex-col space-y-2"
                                  >
                                  <mat-radio-button [value]="true" i18n>Ja</mat-radio-button>
                                  <mat-radio-button [value]="false" i18n>Nein</mat-radio-button>
                                </mat-radio-group>
                                @if (!feedbackForm.get('category.isCorrect')?.value) {
                                  <div
                                    class="mt-4"
                                    >
                                    <mat-form-field class="w-full">
                                      <mat-select
                                        formControlName="newCategories"
                                        multiple
                                        i18n-placeholder
                                        placeholder="Neue Kategorien"
                                        >
                                        @for (category of allCategories; track category) {
                                          <mat-option
                                            [value]="category.id"
                                            >
                                            {{ category.name }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                    <mat-form-field class="w-full mt-4" appearance="outline">
                                      <textarea
                                        matInput
                                        formControlName="reason"
                                        i18n-placeholder
                                        placeholder="Begründung"
                                        rows="3"
                                      ></textarea>
                                    </mat-form-field>
                                  </div>
                                }
                              </div>
                              <div class="flex">
                                <button mat-button matStepperPrevious i18n>Zurück</button>
                                <button
                                  matStepperNext
                                  class="button-blue"
                                  class="button-blue"
                                  [disabled]="!feedbackForm.get('category')?.valid"
                                  i18n
                                  >
                  Weiter
                </button>
                              </div>
                            </mat-step>
                            <!-- Step 3: Content Comprehensible -->
                            <mat-step formGroupName="comprehensibleContent">
                              <div class="py-4">
                                <div class="flex flex-row items-center gap-2">
                                  <p class="text-lg font-semibold" i18n>Inhalte verständlich</p>
                                  <button
                                    class="text-blue-500 hover:text-blue-700"
                                    (click)="openInfoComprehensible()"
                                    i18n
                                    >
                    Was ist zu beachten
                  </button>
                                  <span class="material-symbols-outlined"> help </span>
                                </div>
                                <mat-radio-group
                                  formControlName="isComprehensible"
                                  class="flex flex-col space-y-2"
                                  >
                                  <mat-radio-button [value]="true" i18n>Ja</mat-radio-button>
                                  <mat-radio-button [value]="false" i18n>Nein</mat-radio-button>
                                </mat-radio-group>
                                @if (
                                  !feedbackForm.get('comprehensibleContent.isComprehensible')
                                  ?.value
                                  ) {
                                  <div
                                    class="mt-4"
                                    >
                                    <mat-form-field class="w-full" appearance="outline">
                                      <textarea
                                        matInput
                                        formControlName="reason"
                                        i18n-placeholder
                                        placeholder="Begründung"
                                        rows="3"
                                      ></textarea>
                                    </mat-form-field>
                                  </div>
                                }
                              </div>
                              <div class="flex">
                                <button mat-button matStepperPrevious i18n>Zurück</button>
                                <button
                                  matStepperNext
                                  class="button-blue"
                                  class="button-blue"
                                  [disabled]="!feedbackForm.get('comprehensibleContent')?.valid"
                                  i18n
                                  >
                  Weiter
                </button>
                              </div>
                            </mat-step>
                            <!-- Step 4: Type Correct -->
                            <mat-step formGroupName="type">
                              <div class="py-4">
                                <div class="flex flex-row items-center gap-2">
                                  <p class="text-lg font-semibold" i18n>Typ korrekt</p>
                                  <button
                                    class="text-blue-500 hover:text-blue-700"
                                    (click)="openInfoType()"
                                    i18n
                                    >
                    Was ist zu beachten
                  </button>
                                  <span class="material-symbols-outlined"> help </span>
                                </div>
                                <mat-radio-group
                                  formControlName="isCorrect"
                                  class="flex flex-col space-y-2"
                                  >
                                  <mat-radio-button [value]="true" i18n>Ja</mat-radio-button>
                                  <mat-radio-button [value]="false" i18n>Nein</mat-radio-button>
                                </mat-radio-group>
                                @if (!feedbackForm.get('type.isCorrect')?.value) {
                                  <div
                                    class="mt-4"
                                    >
                                    <mat-form-field class="w-full">
                                      <mat-select
                                        formControlName="newType"
                                        i18n-placeholder
                                        placeholder="Neuer Typ"
                                        >
                                        <mat-select-trigger>
                                          @if (selectedOfferType) {
                                            <div
                                              class="flex items-center"
                                              >
                                              <mat-icon class="mr-2">{{
                                                selectedOfferType.icon
                                              }}</mat-icon>
                                              <span>{{ selectedOfferType.offerName }}</span>
                                            </div>
                                          }
                                        </mat-select-trigger>
                                        @for (type of offerTypes; track type) {
                                          <mat-option
                                            [value]="type.id"
                                            >
                                            <div class="flex items-center">
                                              <mat-icon class="mr-2">{{ type.icon }}</mat-icon>
                                              <span>{{ type.offerName }}</span>
                                            </div>
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                    <mat-form-field class="w-full mt-4" appearance="outline">
                                      <textarea
                                        matInput
                                        formControlName="reason"
                                        i18n-placeholder
                                        placeholder="Begründung"
                                        rows="3"
                                      ></textarea>
                                    </mat-form-field>
                                  </div>
                                }
                              </div>
                              <div class="flex">
                                <button mat-button matStepperPrevious i18n>Zurück</button>
                                <button
                                  matStepperNext
                                  class="button-blue"
                                  class="button-blue"
                                  [disabled]="!feedbackForm.get('type')?.valid"
                                  i18n
                                  >
                  Weiter
                </button>
                              </div>
                            </mat-step>
                            <!-- Step 5: Link Correct -->
                            <mat-step formGroupName="link">
                              <div class="py-4">
                                <div class="flex flex-row items-center gap-2">
                                  <p class="text-lg font-semibold" i18n>Verknüpfung korrekt</p>
                                  <button
                                    class="text-blue-500 hover:text-blue-700"
                                    (click)="openInfoLink()"
                                    i18n
                                    >
                    Was ist zu beachten
                  </button>
                                  <span class="material-symbols-outlined"> help </span>
                                </div>
                                <mat-radio-group
                                  formControlName="isCorrect"
                                  class="flex flex-col space-y-2"
                                  >
                                  <mat-radio-button [value]="true" i18n>Ja</mat-radio-button>
                                  <mat-radio-button [value]="false" i18n>Nein</mat-radio-button>
                                </mat-radio-group>
                                @if (!feedbackForm.get('link.isCorrect')?.value) {
                                  <div
                                    class="mt-4"
                                    >
                                    <mat-form-field class="w-full" appearance="outline">
                                      <textarea
                                        matInput
                                        formControlName="reason"
                                        i18n-placeholder
                                        placeholder="Begründung"
                                        rows="3"
                                      ></textarea>
                                    </mat-form-field>
                                  </div>
                                }
                              </div>
                              <div class="flex">
                                <button mat-button matStepperPrevious i18n>Zurück</button>
                                <button
                                  matStepperNext
                                  class="button-blue"
                                  class="button-blue"
                                  [disabled]="!feedbackForm.get('link')?.valid"
                                  i18n
                                  >
                  Weiter
                </button>
                              </div>
                            </mat-step>
                            <!-- Step 6: Image Appropriate -->
                            <mat-step formGroupName="image">
                              <div class="py-4">
                                <div class="flex flex-row items-center gap-2">
                                  <p class="text-lg font-semibold" i18n>Medien angemessen</p>
                                  <button
                                    class="text-blue-500 hover:text-blue-700"
                                    (click)="openInfoImage()"
                                    i18n
                                    >
                    Was ist zu beachten
                  </button>
                                  <span class="material-symbols-outlined"> help </span>
                                </div>
                                <mat-radio-group
                                  formControlName="isAppropriate"
                                  class="flex flex-col space-y-2"
                                  >
                                  <mat-radio-button [value]="true" i18n>Ja</mat-radio-button>
                                  <mat-radio-button [value]="false" i18n>Nein</mat-radio-button>
                                </mat-radio-group>
                                @if (!feedbackForm.get('image.isAppropriate')?.value) {
                                  <div
                                    class="mt-4"
                                    >
                                    <mat-form-field class="w-full" appearance="outline">
                                      <textarea
                                        matInput
                                        formControlName="reason"
                                        i18n-placeholder
                                        placeholder="Begründung"
                                        rows="3"
                                      ></textarea>
                                    </mat-form-field>
                                  </div>
                                }
                              </div>
                              <div class="flex">
                                <button mat-button matStepperPrevious i18n>Zurück</button>
                                <button
                                  matStepperNext
                                  class="button-blue"
                                  class="button-blue"
                                  [disabled]="!feedbackForm.get('image')?.valid"
                                  i18n
                                  >
                  Weiter
                </button>
                              </div>
                            </mat-step>
                            <!-- Final Step: Decision -->
                            <mat-step>
                              <div class="py-4">
                                <div class="flex flex-row items-center gap-2">
                                  <p class="text-lg font-semibold" i18n>Entscheidung</p>
                                  <button
                                    class="text-blue-500 hover:text-blue-700"
                                    (click)="openInfoDecision()"
                                    i18n
                                    >
                    Was ist zu beachten
                  </button>
                                  <span class="material-symbols-outlined"> help </span>
                                </div>
                                <mat-radio-group
                                  formControlName="finalDecision"
                                  class="flex flex-col space-y-2"
                                  >
                                  <mat-radio-button value="APPROVE" i18n
                                    >Angebot annehmen</mat-radio-button
                                    >
                                    <mat-radio-button value="REJECT" i18n
                                      >Angebot ablehnen</mat-radio-button
                                      >
                                      <mat-radio-button value="REQUEST_MODIFICATION" i18n
                                        >Änderungen anfordern</mat-radio-button
                                        >
                                      </mat-radio-group>
                                      @if (feedbackForm.get('finalDecision')?.value === 'reject') {
                                        <div
                                          class="mt-4"
                                          >
                                          <mat-form-field class="w-full" appearance="outline">
                                            <textarea
                                              matInput
                                              formControlName="rejectionReason"
                                              i18n-placeholder
                                              placeholder="Ablehnungsgrund"
                                              rows="3"
                                            ></textarea>
                                          </mat-form-field>
                                        </div>
                                      }
                                    </div>
                                    <div class="flex">
                                      <button mat-button matStepperPrevious i18n>Zurück</button>
                                      <button
                                        matStepperNext
                                        class="button-blue"
                                        [disabled]="!feedbackForm.valid"
                                        i18n
                                        >
                  Feedback überprüfen
                </button>
                                    </div>
                                  </mat-step>
                                  <!-- Review Step -->
                                  <mat-step>
                                    <div class="py-4">
                                      <h2 class="text-2xl font-bold mb-6" i18n>
                  Feedback überprüfen
                </h2>
                                      <p class="text-gray-600 mb-6" i18n>
                  Bitte überprüfen Sie Ihr Feedback sorgfältig, bevor Sie es
                  absenden.
                </p>
                                      <app-feedback-details
                                        [feedback]="getFeedbackPreview()"
                                        [categories]="allCategories"
                                        [offerTypes]="offerTypes"
                                      ></app-feedback-details>
                                      <div class="flex justify-between mt-6">
                                        <button
                                          mat-button
                                          matStepperPrevious
                                          [disabled]="loadingStates.submitting"
                                          i18n
                                          >
                    Zurück
                  </button>
                                        <button
                                          class="button-blue"
                                          (click)="submitFeedback()"
                                          [disabled]="!feedbackForm.valid || loadingStates.submitting"
                                          i18n
                                          >
                    {{
                      loadingStates.submitting
                        ? "Wird gesendet..."
                        : "Feedback abschicken"
                    }}
                  </button>
                                      </div>
                                    </div>
                                  </mat-step>
                                </mat-stepper>
                              </form>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
